import { AuthUtil } from '../util/auth-util';
var AuthApi = /** @class */ (function () {
    function AuthApi() {
    }
    AuthApi.tokenAdmin = function (usuario, senha) {
        var urlToken = "".concat(AuthUtil.BACK_END_URL, "/api/auth/admin");
        var requestInit = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                username: usuario,
                password: senha,
            }),
        };
        return fetch(urlToken, requestInit);
    };
    AuthApi.tokenUserMtCidadao = function (usuario, token) {
        var urlToken = "".concat(AuthUtil.BACK_END_URL, "/api/auth/portal");
        var requestInit = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                username: usuario,
                token: token !== null && token !== void 0 ? token : '',
            }),
        };
        return fetch(urlToken, requestInit);
    };
    return AuthApi;
}());
export { AuthApi };
